import { render, staticRenderFns } from "./UspList.vue?vue&type=template&id=4272fb00&"
import script from "./UspList.vue?vue&type=script&lang=js&"
export * from "./UspList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports